<div id="group-company-management-view" class="page-layout blank">
    <div class="content">
        <div class="left">
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="20">
                    <app-grupos-empresa-list
                        [empresasDisponibles]="empresasDisponibles"
                        (grupoChanged)="grupoClicked($event)"
                        (crearGrupo)="nuevoGrupo()">
                    </app-grupos-empresa-list>
                </div>

                <div class="widget user-management-view" fxFlex="100" fxFlex.gt-sm="80">
                    <app-grupos-empresa-details
                        [grupo]="selectedGrupo"
                        [empresasDisponibles]="empresasDisponibles"
                        [modo]="modo">
                    </app-grupos-empresa-details>
                </div>
            </div>
        </div>
    </div>
</div>